var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAccountDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm2.498 3h2.476c2.732 0 5.453 2.112 4.97 5.094-.54 3.315-2.983 5.893-2.983 5.893H8.055l-.049-.062c-.37-.463-2.421-3.025-2.937-5.831C4.522 17.123 7.304 15 10.036 15h2.476c.532.899 1.448 1.496 2.493 1.496s1.961-.597 2.493-1.496zm5.002 3.101C21.932 17.432 20.94 17 19.974 17h-1.499c-.918.952-2.15 1.496-3.47 1.496A4.8 4.8 0 0 1 11.536 17h-1.5c-.99 0-2.002.445-2.575 1.133-.397.477-.536 1-.426 1.6.233 1.267.955 2.784 2.01 4.254h11.976c.631-.834 1.655-2.418 1.947-4.214a1.986 1.986 0 0 0-.468-1.672z",
    fill: "url(#60advsu07a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "60advsu07a",
    x1: 5,
    y1: 4,
    x2: 5,
    y2: 25.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80BDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#628BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountDark);
export default __webpack_public_path__ + "static/media/ic-account-dark.fd9e7ec0b299b99b46017c87b9959c85.svg";
export { ForwardRef as ReactComponent };